import { useCallback, useEffect, useState } from "preact/compat";
import { api_url, front_url } from "../../config/constant";
import { useAppContext } from "../../context/AppContext";
import { parseUrl, preloadImage } from "../../utils/misc";
import { trans } from "../../utils/utilsTrans";

const LoadingScreen = ({ images, setAssetsLoaded, translations }) => {
  const { unconfiguredScreen } = useAppContext();

  const [percentLoaded, setPercentLoaded] = useState(0);

  useEffect(() => {
    if (Array.isArray(images)) {
      if (images.length !== 0) {
        getPictures();
      } else {
        setAssetsLoaded(true);
      }
    }

  }, [images?.length]);

  const getPictures = useCallback(() => {
    async function effect() {
      let percentage = 0;
      let numberLoaded = 0;
      let numberRejected = 0;
      const imagesPromiseList = [];

      images.map((src) => {
        if (!window[src]) {
          imagesPromiseList.push(
            preloadImage(src)
              .then(() => {})
              .catch((image) => {
                numberRejected += 1;

                if (!window?.blacklist?.includes(image.src)) {
                  window.blacklist = [...(window?.blacklist || []), image.src];
                }
              })
              .finally(() => {
                numberLoaded += 1;
                percentage = (numberLoaded / images.length) * 100;
                setPercentLoaded(percentage);
              })
          )
        }
      });

      await Promise.all(imagesPromiseList);

      if (numberRejected && numberRejected >= images.filter((url) => ![parseUrl(api_url).hostname, parseUrl(front_url).hostname].includes(parseUrl(url).hostname)).length) {
        unconfiguredScreen();
      }

      setAssetsLoaded(true);
    }

    effect();
  }, [images, preloadImage]);

  return (
    <div className='loader'>
      <div>
        <h1>{trans('loading', translations)}</h1>
        <div className='progressbar-container'>
          <div className='progressbar-content'>
            <div className='progressbar' style={{ width: `${percentLoaded}%` }} />
          </div>
          <div className='percentage'>{Math.round(percentLoaded)}%</div>
        </div>
      </div>
    </div>
  )
}

export default LoadingScreen
